import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class HttpOnlineAuthorsInterceptor implements HttpInterceptor {
    public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const modifiedHeaders = req.headers.set('scope', 'AUT');
        const clonedReq = req.clone({ headers: modifiedHeaders });

        return next.handle(clonedReq);
    }
}
